export const OTHER_DATES_SUGGESTED = 'OTHER_DATES_SUGGESTED';
export const AVAILABLE_OTHER_DATES_SUGGESTED = 'AVAILABLE_OTHER_DATES_SUGGESTED';
export const NO_AVAILABLE_OTHER_DATES_SUGGESTED = 'NO_AVAILABLE_OTHER_DATES_SUGGESTED';
export const OTHER_DATES_SELECTED = 'OTHER_DATES_SELECTED';
